import ActivityIndicator from './activity-indicator.jsx';

export default ActivityIndicator; 